import { Component, Input, inject } from "@angular/core";
import { Hss } from "../models/hss";
import { HssLeg } from "../models/hss-leg";
import { HssBuilderService } from "../hss-builder.service";
import { HssTimePipe } from "../pipes/hss-time.pipe";
import { HssDurationPipe } from "../pipes/hss-duration";
import { HssItem } from "../models/hss-item";

@Component({
  selector: "app-act-row",
  standalone: true,
  imports: [HssTimePipe, HssDurationPipe],
  templateUrl: "./act-row.component.html",
  styleUrls: ["./act-row.component.scss", "../hss-builder.component.scss"],
})
export class ActRowComponent {
  @Input({ required: true }) hss!: Hss;
  @Input({ required: true }) leg!: HssLeg;
  @Input() enhanced?: boolean;
  @Input() index?: number;

  hssBuilderService = inject(HssBuilderService);

  // Maintain array of leg remarks. Gets reset for each leg displayed.
  // Needed for generating blank lines when there are multiple remarks.
  legRemarks: HssItem[] = [];

  setLegRemarks(leg: HssLeg): void {
    const remarks: HssItem[] = [];

    if (leg.rampDelayMinutes.text !== "") {
      remarks.push(leg.rampDelayMinutes);
    }
    if (leg.atcDelayMinutes.text !== "") {
      remarks.push(leg.atcDelayMinutes);
    }
    if (leg.deicingDelayMinutes.text !== "") {
      remarks.push(leg.deicingDelayMinutes);
    }
    if (leg.diversionTime.text !== "0.00") {
      remarks.push(leg.diversionTime);
    }
    if (leg.isDiversion.text === "True") {
      remarks.push(leg.isDiversion);
    }
    if (leg.isGroundInterrupt.text === "True") {
      remarks.push(leg.isGroundInterrupt);
    }
    if (leg.isStub.text === "True") {
      remarks.push(leg.isStub);
    }
    if (leg.isAirInterrupt.text === "True") {
      remarks.push(leg.isAirInterrupt);
    }

    this.legRemarks = remarks;
  }
}
